<template>
  <div class="page">
    <section id="content">
      <div class="container">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 col-md-offset-1">
              <PageText v-bind="text"></PageText>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageText from "../components/PageText";
import { setBreadcrumbsMixin } from "../mixins/setBreadcrumbs";
import { mapGetters } from "vuex";

export default {
  components: {
    PageText
  },
  mixins: [setBreadcrumbsMixin],
  props: ["slug"],
  created() {
    this.fetchPageText();
  },
  watch: {
    $route: "fetchPageText"
  },
  computed: mapGetters("text", ["getText"]),
  data() {
    return {
      text: {}
    };
  },
  methods: {
    fetchPageText() {
      this.$store.dispatch("text/fetchTexts").then(() => {
        this.text = this.getText(this.slug);
        if (this.text === undefined) {
          this.$router.replace({name: "404"});
        } else {
          this.setBreadcrumbs([
            {text: 'Home', to:{name: "home"}},
            {text: this.text.title}
          ]);
        }
      });
    }
  }
};
</script>
